import HelloIndex from "./HelloIndex.vue";
import Tables from "./Tables/Tables.vue"; // 表格
import Dialogs from "./Dialogs/Dialogs.vue"; // 弹出框
import Pages from "./Paginations/Paginations.vue"; // 分页
import Breadcrumbs from "./Breadcrumbs/Breadcrumbs.vue"; // 面包屑
import Menus from "./Menus/Menus.vue"; // 菜单
import Headers from "./Headers/Headers.vue"; // 头部
import State from "./State/State.vue";
import phoneCode from "./phoneCode/phoneCode.vue"; //获取验证码
import upload from "./Upload/upload"; //企业认证上传
import BankDialog from "./addBankDialog/addBankDialog"; //企业认证银行新增
import addressDialog from "./addressDialog/addressDialog"; //企业地址新增

import putOnRecord from "./putOnRecord/putOnRecord"; //环保备案
import commonVehicles from "./commonVehicles/commonVehicles"; // 常用车辆  新增 编辑
import commonVehiclesList from "./commonVehiclesList/commonVehiclesList"; // 常用车辆列表

import commonVessel from "./commonVessel"; //    我的船舶  新增 编辑
import commonVesselList from "./commonVesselList"; // 我的船舶列表

import vehicleDelivery from "./vehicleDelivery/vehicleDelivery"; //派车送货

import whiteSlipPayment from "./whiteSlipPayment/whiteSlipPayment"; //白条支付
import whiteSlipPaymentTwo from "./whiteSlipPaymentTwo/whiteSlipPaymentTwo"; //白条支付

import mapTrajectory from "./mapTrajectory/mapTrajectory"; //地图轨迹
import contractSign from "./contract-sign/index"; //地图轨迹
export default {
  install(Vue) {
    Vue.component("HelloIndex", HelloIndex);
    Vue.component("Tables", Tables);
    Vue.component("Dialogs", Dialogs);
    Vue.component("Pages", Pages);
    Vue.component("Breadcrumbs", Breadcrumbs);
    Vue.component("Menus", Menus);
    Vue.component("Headers", Headers);
    Vue.component("State", State);
    Vue.component("phoneCode", phoneCode);
    Vue.component("upload", upload);
    Vue.component("BankDialog", BankDialog);
    Vue.component("addressDialog", addressDialog);
    Vue.component("putOnRecord", putOnRecord);
    Vue.component("vehicleDelivery", vehicleDelivery);
    Vue.component("whiteSlipPayment", whiteSlipPayment);
    Vue.component("whiteSlipPaymentTwo", whiteSlipPaymentTwo);
    Vue.component("mapTrajectory", mapTrajectory);
    Vue.component("commonVehicles", commonVehicles);
    Vue.component("commonVehiclesList", commonVehiclesList);
    Vue.component("commonVessel", commonVessel);
    Vue.component("commonVesselList", commonVesselList);
    Vue.component("contractSign", contractSign);
  },
};
